import moment from "moment";
import React, { useEffect } from "react";
import { getCurrentFinancialYear } from "../../CommonMethhods/CommonMethods";

export default function DurationChangeComponent(props) {
  let setCustomShow = props.setCustomShow;
  let setFromDate = props.setFromDate;
  let setToDate = props.setToDate;
  let showOptionCustom = props.showOptionCustom ?? true;
  let showOnlyFY = props.showOnlyFY ?? true
  console.log("duration prop", props?.onChangeDuration);

  //     useEffect(() => {
  //     if (props.screen === "Client Dashboard" && props?.reportName === "pnl") {
  //         props.setSelectDuration("currentmnth");
  //     }
  // }, [props.screen, props?.reportName]);

  const onChangeDuration = (e) => {
    let val = e.target.value;
    if (props.screen !== "Client Dashboard" || props?.reportName === "pnl") {
      props.setSelectDuration(val);
    }
    props.onChangeDuration && props.onChangeDuration();
    let date = new Date();
    let firstDay = "";
    let lastDay = "";
    console.log("val", val);
    if (val == "custom") {
      setCustomShow(true);
    } else if (val == "currentmnth") {
      setCustomShow(false);
      let firstVal = new Date(date.getFullYear(), date.getMonth(), 1);
      firstDay = moment(firstVal, "MM-DD-YYYY").format("MM-DD-YYYY");
      let lastVal = new Date();
      lastDay = moment(lastVal, "MM-DD-YYYY").format("MM-DD-YYYY");
      console.log("first", firstDay, firstVal);
    } else if (val == "lastmnth") {
      setCustomShow(false);
      let firstVal = new Date(date.getFullYear(), date.getMonth() - 1, 1);
      firstDay = moment(firstVal, "MM-DD-YYYY").format("MM-DD-YYYY");
      let lastVal = new Date(date.getFullYear(), date.getMonth(), 0);
      lastDay = moment(lastVal, "MM-DD-YYYY").format("MM-DD-YYYY");
    } else if (val == "currentyr") {
      setCustomShow(false);
      let currentFyearStart = new Date(getCurrentFinancialYear(date).startDate);
      //   let currentFyearEnd = new Date(getCurrentFinancialYear(date).endDate);
      let firstVal = new Date(
        currentFyearStart.getFullYear(),
        currentFyearStart.getMonth(),
        1,
      );
      firstDay = moment(firstVal, "MM-DD-YYYY").format("MM-DD-YYYY");

      // let lastVal = new Date(
      //     currentFyearEnd.getFullYear(),
      //     currentFyearEnd.getMonth(),
      //     31
      // );
      let lastVal = new Date();
      lastDay = moment(lastVal, "MM-DD-YYYY").format("MM-DD-YYYY");
      console.log("current yr", firstDay, lastDay);
    } else if (val == "lastyr") {
      setCustomShow(false);
      let currentFyearStart = new Date(getCurrentFinancialYear(date).startDate);
      let currentFyearEnd = new Date(getCurrentFinancialYear(date).endDate);
      let firstVal = new Date(
        currentFyearStart.getFullYear() - 1,
        currentFyearStart.getMonth(),
        1,
      );
      firstDay = moment(firstVal, "MM-DD-YYYY").format("MM-DD-YYYY");
      let lastVal = new Date(
        currentFyearEnd.getFullYear() - 1,
        currentFyearEnd.getMonth(),
        31,
      );
      lastDay = moment(lastVal, "MM-DD-YYYY").format("MM-DD-YYYY");
      console.log("last yr", firstDay, lastDay);
    } else {
      setCustomShow(false);
      props.setSelectDuration("");
    }
    setFromDate(firstDay);
    setToDate(lastDay);
  };

  // Placeholder stays grey; once a real duration is chosen the select gets
  // this class so its shown value turns white.
  const hasSelectedValue = Boolean(props?.selectDuration);

  return (
    <div>
      <label className="form-label">
        Duration{props.required && <span className="required">*</span>}
      </label>
      {props.screen == "Client Dashboard" ? (
        <select
          onChange={onChangeDuration}
          value={
            props?.reportName === "pnl" ? props?.selectDuration : undefined
          }
          // value={props?.reportName === "pnl" && props?.selectDuration}
          className={`${props.className ? props.className : ""}${
            hasSelectedValue ? " has-selected-value" : ""
          }`}
        >
          {showOnlyFY && (
            <>
              <option value="currentmnth">Current Month</option>
              <option value="lastmnth">Last Month</option>
            </>
          )}
          <option value="currentyr">Current Fin. Year</option>
          <option value="lastyr">Last Fin. Year</option>
          {showOptionCustom && <option value="custom">Custom</option>}
        </select>
      ) : (
        <select
          onChange={onChangeDuration}
          value={props?.selectDuration}
          className={hasSelectedValue ? "has-selected-value" : ""}
        >
          <option value="">Please Select</option>
          {showOnlyFY && (
            <>
              <option value="currentmnth">Current Month</option>
              <option value="lastmnth">Last Month</option>
            </>
          )}
          <option value="currentyr">Current Fin. Year</option>
          <option value="lastyr">Last Fin. Year</option>
          {showOptionCustom && <option value="custom">Custom</option>}
        </select>
      )}
    </div>
  );
}
